import React, { Component } from 'react';
import Layout from './containers/Layout';
import { Grid, Card, CardHeader, CardActions, Box } from '@material-ui/core';
import { MiniCardStoreHouse } from '../../../commonModules/layouts/CardPage';

class Inventory extends Component {
    state = { }
    
    changeTab = (page, openNew = false) => { 
        this.props.changePage(page, openNew)
    }

    render(){
        console.log("[STATE] Inventory MainStock");
        return(
            <Box
                p={1} 
                style={{ 
                    minHeight: `750px`,
                    marginTop: "200px",
                }}
            >
                <div
                    style={{
                        background: "url(/img/bckgWaves3.svg)",
                        backgroundSize: "cover",
                        backgroundPosition: "left",
                        position: "absolute",
                        height: "900px",
                        width: "100%",
                        zIndex: "-10",
                        left: "0",
                        top: "0"
                    }}
                ></div>
            {/* <div className="container" style={{ minHeight: `750px`}}> */}
                <Card elevation={0} square>
                    <Box p={2}>
                        <Grid container spacing={2} >
                            <Grid item sm={4} xs={12}>
                                <MiniCardStoreHouse blob="blobBlue.svg" title="Stocks" actions={() => this.changeTab("stocks")} />
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <MiniCardStoreHouse blob="blobRed.svg" title="Produits" actions={() => this.changeTab("prods")} actionNew={() => this.changeTab("prods", true)} />
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <MiniCardStoreHouse blob="blobYellow.svg" title="Magasins" actions={() => this.changeTab("shops")} />
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <MiniCardStoreHouse blob="blobPurple.svg" title="Ventes" actions={() => this.changeTab("sales")} actionNew={() => this.changeTab("sales", true)} />
                            </Grid>
                            
                            <Grid item sm={4} xs={12}>
                                <MiniCardStoreHouse blob="blobGreen.svg" title="Achats" actions={() => this.changeTab("purchases")} actionNew={() => this.changeTab("purchases", true)}/>
                            </Grid>
                            <Grid item sm={4} xs={12}>
                                <MiniCardStoreHouse blob="blobPink.svg" title="Réappro" actions={() => this.changeTab("reappro")} actionNew={() => this.changeTab("reappro", true)} />
                            </Grid>
                        </Grid>                                                    
                    </Box>
                </Card>
            </Box>
        )
    }
    
}



export default Inventory